import React from 'react';
import MenuIcon from "@material-ui/icons/Menu";
// import NotificationsIcon from "@material-ui/icons/Notifications";
//import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PropTypes from 'prop-types';
import { Toolbar, IconButton, Typography, /* Tooltip, */ withStyles, Menu, MenuItem, ListItemAvatar, Avatar, ListItemText } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { useBeforeunload } from 'react-beforeunload';
import { LightMode, Logout, Nightlight } from '@mui/icons-material';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  }
})(props => (
  <Menu
    style={
      {
        width: '100%',
        maxWidth: 360,
      }
    }
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

const MenuToolbar = props => {
  // const { classes, handleSliderDrawerOpen, notifications, onNotification, onLogout } = props
  const { classes, handleSliderDrawerOpen, notifications, onLogout, setOnLogoutClose } = props
  const [anchorEl, setAnchorEl] = React.useState(null);

  useBeforeunload((event) => handleCloseEyelash(event));

  const handleCloseEyelash = (event) => {
    //console.log(event)
    //event.returnValue = "dfgdfgdfg"
    setOnLogoutClose()
    //event.preventDefault()

    //
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Toolbar>
      <IconButton
        color="inherit"
        aria-label="open drawer"
        edge="start"
        onClick={handleSliderDrawerOpen}
        className={classes.menuButton}
      >
        <MenuIcon style={{ color: '#FFFFFF' }} />
      </IconButton>
      {
        isMobile ?
          <Typography
            /* variant="h6"
            noWrap
            className={classes.title}
            align='center' */
            justify='center'
            style={{ color: '#FFFFFF', flexGrow: 1 }}
          >
            <img src={process.env.PUBLIC_URL + '/images/logo_en_bn.svg'} alt="Logo" style={{ width: '70%' }} /* className={classes.title} */ />
          </Typography> :
          <Typography
            variant="h6"
            noWrap
            className={classes.title}
            align='center'
            style={{ color: '#FFFFFF' }}
          >
            Bienvenido a tu Banca Empresas
          </Typography>
      }

      {/* {<IconButton color="inherit" onClick = {  handleClick } >
              <Badge badgeContent={notifications.length || 0} color="secondary">
                <NotificationsIcon />
              </Badge>
            </IconButton>} */}
      {
        (notifications.length > 0) &&
        <StyledMenu
          id="customized-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {
            notifications.map(notification => {
              return <MenuItem key={notification.id} >
                <ListItemAvatar>
                  <Avatar alt="Remy Sharp"> {notification.type.charAt(0)}</Avatar>
                </ListItemAvatar>
                <ListItemText primary={notification.type}
                  secondary={notification.createdAt} />
              </MenuItem>
            })
          }
        </StyledMenu>
      }
      <IconButton style={{ marginRight: 32 }} color="inherit" edge="end" onClick={() => props.handleDarkTheme()}>
        {props.isDark ? <LightMode /> : <Nightlight /> }
      </IconButton>
      <IconButton color="inherit" edge="end" onClick={() => onLogout()}>
        {!isMobile && <Typography
          variant="h6"
          //noWrap
          // className={classes.title}
          align='right'
          style={{ color: '#FFFFFF', fontSize: 12 }}
        >
          Cerrar sesión
        </Typography>}
        <Logout style={{ marginLeft: 8 }} />
        {/* <Tooltip title="Cerrar sesión" aria-label="add">
          <ExitToAppIcon style={{ color: '#FFFFFF' }} /></Tooltip> */}
      </IconButton>
    </Toolbar>
  );
};

MenuToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  handleSliderDrawerOpen: PropTypes.func.isRequired,
  notifications: PropTypes.array.isRequired,
};

export default MenuToolbar;